
import { Box, Toolbar, Zoom, useScrollTrigger } from "@mui/material";


export default function ScrollTop({children}) {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor");
    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <Box onClick={handleClick} sx={{position: 'fixed', bottom: 2, right: 2,}}>
        {children}
      </Box>
    </Zoom>
  );
}

export const BackToTopAnchor = () => (
  <Toolbar id="back-to-top-anchor" />
);
